<template>
  <v-dialog v-model="visibility" persistent max-width="438px">
    <v-card v-if="visibility" class="rounded-xl py-2">
      <!-- Title -->
      <v-card-title class="pa-6">
        <h4 class="text-capitalize dialog-title">
          <span v-if="type === 'discard'">{{ t('$vuetify.__General.confirm') }} {{ t('$vuetify.__Approval.discard_changes') }}?</span>
          <span v-else-if="type === 'submit'">{{ t('$vuetify.__General.confirm') }} {{ t('$vuetify.__Approval.submission') }}?</span>
        </h4>
      </v-card-title>

      <!-- Hint -->
      <v-card-text>
        <span v-if="type === 'discard'">{{ t('$vuetify.__Approval.discard_hint') }}</span>
        <span v-else-if="type === 'submit'">{{ t('$vuetify.__Approval.submission_hint', item.device_name) }}</span>
      </v-card-text>

      <!-- Action buttons -->
      <v-row no-gutters class="px-6 py-4">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" rounded :disabled="submit_btn_disable" class="text-capitalize px-3" @click="store.commit('RESET_CHANGES_ACTION_DIALOG')">
          {{ t('$vuetify.__General.cancel') }}
        </v-btn>
        <v-btn color="#1b65f2" rounded :dark="!submit_btn_disable" :disabled="submit_btn_disable" class="text-capitalize px-3 ml-2" @click="confirm">
          {{ t('$vuetify.__General.confirm') }}
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

import { useStore } from 'vuex'
const store = useStore()
import { useLocale } from 'vuetify'
const { t } = useLocale()

const submit_btn_disable = computed(() => store.state.changesActionDialog.submit_btn_disable)
const visibility = computed(() => store.state.changesActionDialog.visibility)
const type = computed(() => store.state.changesActionDialog.type)
const item = computed(() => store.state.changesActionDialog.item)

const confirm = () => {
  if (type.value === 'discard') {
    store.commit('SET_CHANGES_APPROVAL_DIALOG_PAGE', 0)
    store.commit('RESET_CHANGES_ACTION_DIALOG')
  } else if (type.value === 'submit') {
    store.dispatch('submitChanges')
  }
}
</script>
